import * as React from 'react';

/** A rising line on axes: delivery over time. Outline, currentColor, so it
 *  takes the sidebar's colour like every other row. */
function ChartLineUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M5 6v20h22M9 20l5-6 5 4 7-9M26 14V9h-5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ChartLineUp;
